import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TextInput } from '@components';
import { TransitViewStakeholdersFormValues } from './validateTransitViewStakeholdersForm';

interface RepresentativeSectionProps {
  form: UseFormReturnType<TransitViewStakeholdersFormValues>;
  editDisabled: boolean;
}

export const RepresentativeSection: React.FC<RepresentativeSectionProps> = ({ form, editDisabled }) => {
  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Representative
      </Title>

      <Grid>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('Representative.identificationNumber')} label="Identification number" disabled={editDisabled} />
        </Grid.Col>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('Representative.status')} label="Status" disabled={editDisabled} />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('Representative.ContactPerson.name')} label="Contact Name" disabled={editDisabled} />
        </Grid.Col>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('Representative.ContactPerson.phoneNumber')} label="Phone Number" disabled={editDisabled} />
        </Grid.Col>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('Representative.ContactPerson.eMailAddress')} label="eMail Address" disabled={editDisabled} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
